module.exports = __webpack_public_path__ + "static/media/Karan More_Resume.e42545a8.pdf";